import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { EVACUATIONS_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_EVACUATIONS_LIST = '_LOAD_EVACUATIONS_LIST';
export const CREATE_EVACUATIONS = '_CREATE_EVACUATIONS';
export const LOAD_EVACUATIONS_BY_ID = '_LOAD_EVACUATIONS_BY_ID';
export const EDIT_EVACUATIONS_BY_ID = '_EDIT_EVACUATIONS_BY_ID';
export const DELETE_EVACUATIONS = '_DELETE_EVACUATIONS';

export const loadEvacuationsList = createDeferredAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_LIST);
export const loadEvacuationsListBegin = createDeferredAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_LIST + BEGIN);
export const loadEvacuationsListSuccessful = createAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_LIST + SUCCESSFUL);
export const loadEvacuationsListFailed = createAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_LIST + FAILED);

export const createEvacuations = createDeferredAction(EVACUATIONS_MODULE + CREATE_EVACUATIONS);
export const createEvacuationsSuccessful = createAction(EVACUATIONS_MODULE + CREATE_EVACUATIONS + SUCCESSFUL);
export const createEvacuationsFailed = createAction(EVACUATIONS_MODULE + CREATE_EVACUATIONS + FAILED);

export const loadEvacuationsById = createDeferredAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_BY_ID);
export const loadEvacuationsByIdSuccessful = createAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_BY_ID + SUCCESSFUL);
export const loadEvacuationsByIdFailed = createAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_BY_ID + FAILED);
export const loadEvacuationsByIdClear = createDeferredAction(EVACUATIONS_MODULE + LOAD_EVACUATIONS_BY_ID + CLEAR);

export const editEvacuationsById = createDeferredAction(EVACUATIONS_MODULE + EDIT_EVACUATIONS_BY_ID);
export const editEvacuationsByIdSuccessful = createAction(EVACUATIONS_MODULE + EDIT_EVACUATIONS_BY_ID + SUCCESSFUL);
export const editEvacuationsByIdFailed = createAction(EVACUATIONS_MODULE + EDIT_EVACUATIONS_BY_ID + FAILED);

export const deleteEvacuations = createDeferredAction(EVACUATIONS_MODULE + DELETE_EVACUATIONS);
export const deleteEvacuationsSuccessful = createAction(EVACUATIONS_MODULE + DELETE_EVACUATIONS + SUCCESSFUL);
export const deleteEvacuationsFailed = createAction(EVACUATIONS_MODULE + DELETE_EVACUATIONS + FAILED);
